import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ReplayIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 22 20">
    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.03326 12.9017V5.21313L13.4867 9.05741L7.03326 12.9017ZM7.8712 6.71021V11.4046L11.8109 9.05741L7.8712 6.71021Z" fill="#7B7676" />
      <path d="M1.03333 9.20699C1.03333 13.7752 4.8389 17.4784 9.53333 17.4784C14.2277 17.4784 18.0333 13.7752 18.0333 9.20699C18.0333 4.6388 14.2277 0.935547 9.53333 0.935547C7.52319 0.935547 5.67602 1.61455 4.22083 2.74971" stroke="#7B7676" strokeLinecap="round" />
      <path d="M1.6144 4.90207L3.10371 1.01725L5.89998 4.12661L1.6144 4.90207Z" fill="#7B7676" />
    </svg>
  </SvgIcon>
);
export default ReplayIcon;
